import Cookies from "js-cookie";
import * as url from "./url";
import { parse } from "querystring";
import get from "lodash/get";
const userCookieName = "user";
const userAttributesCookieName = "userAttributes";
const adminLogInCookieName = "adminLogIn";
const adminLogInValue = "true";
const adminLogInTokenCookieName = "adminLogInToken";
export const utmCookieName = "utmParams";
export const utmSource = "utmSource";
export const utmMedium = "utmMedium";
export const utmCampaign = "utmCampaign";
export const utmTerm = "utmTerm";
export const utmContent = "utmContent";
export const inviteUUIDCookieName = "invite_uuid";
const attributeNameCurrentRole = "current_role";

function saveUser(user, config = {}) {
  Cookies.set(userCookieName, JSON.stringify(user), { expires: 7 });
  if (config.admin) {
    Cookies.set(adminLogInCookieName, adminLogInValue, { expires: 7 });
  }
  if (config.adminToken) {
    Cookies.set(adminLogInTokenCookieName, config.adminToken, { expires: 7 });
  }
}

function getAdminToken() {
  return Cookies.get(adminLogInTokenCookieName);
}

function saveUserAttributes(attributes, config = {}) {
  if (!config.admin) {
    const attributeString = Cookies.get(userAttributesCookieName);
    const currentAttributes = attributeString ? JSON.parse(attributeString) : {};
    Cookies.set(userAttributesCookieName, JSON.stringify({ ...currentAttributes, ...attributes }));
  }
}

export function saveUserRole(role, config) {
  saveUserAttributes({ [attributeNameCurrentRole]: role }, config);
}

function getUserRole() {
  const attributeString = Cookies.get(userAttributesCookieName);
  if (!attributeString) {
    return attributeString;
  }
  return get(JSON.parse(attributeString), attributeNameCurrentRole);
}

function getUser() {
  var userString = Cookies.get(userCookieName);
  if (userString) {
    return JSON.parse(userString);
  } else {
    return null;
  }
}

function deleteUser() {
  Cookies.remove(userCookieName);
  Cookies.remove(adminLogInCookieName);
  Cookies.remove(userAttributesCookieName);
}

function isAdminLogin() {
  return Cookies.get(adminLogInCookieName) === adminLogInValue;
}

// If there are any UTM params in the query string, then save them to the cookies.
function saveUTMParams() {
  let queryString = window.location.search;
  if (queryString[0] === "?") {
    queryString = queryString.substring(1);
  }
  const urlParams = parse(queryString);
  const source = get(urlParams, "utm_source");
  const medium = get(urlParams, "utm_medium");
  const campaign = get(urlParams, "utm_campaign");
  const term = get(urlParams, "utm_term");
  const content = get(urlParams, "utm_content");

  if (source || medium || campaign || term || content) {
    Cookies.set(
      utmCookieName,
      {
        [utmSource]: source,
        [utmMedium]: medium,
        [utmCampaign]: campaign,
        [utmTerm]: term,
        [utmContent]: content,
      },
      { expires: 7 }
    );
  }
}

// If the user clicked on a link with an invite uuid save that as a cookie so we can use the invite for sign-up
function saveInviteUUID() {
  let queryString = window.location.search;
  if (queryString[0] === "?") {
    queryString = queryString.substring(1);
  }
  const urlParams = parse(queryString);
  const inviteUUID = get(urlParams, "iu");
  if (inviteUUID) {
    url.removeQueryString("iu");
    Cookies.set(inviteUUIDCookieName, inviteUUID, { expires: 7 });
  }
}

var UserStore = {
  save: saveUser,
  get: getUser,
  remove: deleteUser,
  isAdminLogin,
  getAdminToken,
  saveUTMParams: saveUTMParams,
  saveInviteUUID: saveInviteUUID,
  getUserRole,
};

export default UserStore;
